/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-12-03 12:11:25
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-07 21:06:34
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/ImageWidthTitle/index.tsx
 */
import React, { ReactNode } from 'react';

import ItemWrapper from 'src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import GeneralCollapseContent from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseContent';
import { Uploader, useSingleImageEffect } from 'src/components/Upload';

import { ImageFile } from '@/src/components/Upload/ImageDisplay/imageDisplay';

import _, { get } from 'lodash';
import styles from './css.less';
import FocusPoint from 'src/components/ImageFocusPointEdit';

interface IProps {
  title: string | ReactNode;
  subtitle?: string | ReactNode;
  image?: ImageFile;
  showDisplaySetting?: boolean;
  onImageChange: (value) => void;
}

const ImageWidthTitle = (props: IProps) => {
  //const [visible, setVisible] = useState(false);
  const { title, subtitle, image, onImageChange, showDisplaySetting } = props;

  const [fileList, setFileList] = React.useState(image ? [image] : []);
  // const coordinate =
  //   image?.imageSetting?.left &&
  //   image?.imageSetting?.top &&
  //   image?.imageSetting?.bottom &&
  //   image?.imageSetting?.right
  //     ? {
  //         leftTop: image?.imageSetting?.left,
  //         rightTop: image?.imageSetting?.top,
  //         leftBottom: image?.imageSetting?.bottom,
  //         rightBottom: image?.imageSetting?.right,
  //       }
  //     : undefined;
  // const coordinateFocal = image?.imageSetting?.focus;

  const handleChangeImage = (img) => {
    // const img = cloneDeep(image);
    // img['imageSetting'] = {
    //   focus: focalValue,
    //   left: value.leftTop,
    //   top: value.rightTop,
    //   bottom: value.leftBottom,
    //   right: value.rightBottom,
    // };
    onImageChange(img);
    //setVisible(false);
  };

  useSingleImageEffect(image, fileList, setFileList);
  return (
    <GeneralCollapseContent>
      <ItemWrapper title={title} bottomTitle={subtitle}>
        <Uploader
          type='Image'
          height={180}
          multiple={false}
          fileList={fileList}
          // hideEdit={showDisplaySetting}
          // hideRemove={showDisplaySetting}
          // hideReplace={showDisplaySetting}
          onChange={(imgArr = []) => {
            if (onImageChange) {
              setFileList(imgArr);
              const _l = _.last(imgArr);
              onImageChange(_l);
            }
          }}
        />
        <FocusPoint
          className={styles.imageSetting}
          image={get(fileList, 0)}
          onChange={handleChangeImage}
          disable={!showDisplaySetting}
        />
        {/* {showDisplaySetting && (
          <>
            <div
              className={styles.imageSetting}
              onClick={() => setVisible(!!image?.url)}>
              {'Image Display Setting'}
            </div>
            <ImageDisplaySetting
              src={image?.url}
              value={coordinate}
              visible={visible}
              focalValue={coordinateFocal}
              onCancel={() => setVisible(false)}
              onOk={handleChangeImage}
            />
          </>
        )} */}
      </ItemWrapper>
    </GeneralCollapseContent>
  );
};
export default ImageWidthTitle;
